import { Dispatch, createContext, useCallback, useEffect, useState } from 'react'

import { PaymentType } from 'consts'
import { BranchType } from 'consts/branchType'
import { ICustomerOrder } from 'models'

import { useThemeConfigContext } from './ThemeConfig'

const initData = { isLoan: false, isExtension: false, externalId: '', customerOrderType: '', preQualificationForFreeInstallment: false, preQualificationFreeInstallmentCount: 0}

export type SelectedPaymentType = PaymentType.AUTOPAY_BUSINESS_ACCOUNT | PaymentType.DEBIT_NOTE | null

export const OrderContext = createContext({
  order: null,
  setOrder: () => {},
  contextData: initData,

  selectedPayment: null,
  handleChangesSelectedPayment: () => {},
} as {
  order: ICustomerOrder | null
  setOrder: Dispatch<React.SetStateAction<ICustomerOrder | null>>
  contextData: { isLoan: boolean; isExtension: boolean; externalId: string; customerOrderType: string, preQualificationForFreeInstallment: boolean, preQualificationFreeInstallmentCount: number}

  selectedPayment: SelectedPaymentType
  handleChangesSelectedPayment: (val: SelectedPaymentType) => void
})

export const OrderContextProvider = ({ children }: any) => {
  const { setTheme } = useThemeConfigContext()
  const [order, setOrder] = useState<ICustomerOrder | null>(null)
  const [data, setData] = useState(initData)
  const [selectedPayment, setSelectedPayment] = useState<SelectedPaymentType>(null)

  useEffect(() => {
    if (order) {
      setData({
        isLoan: order?.branch === BranchType.CREDIT,
        isExtension: Boolean(order.extension),
        externalId: String(order.externalId),
        customerOrderType: String(order.callerId),
        preQualificationForFreeInstallment: order?.preQualificationForFreeInstallment ?? false,
        preQualificationFreeInstallmentCount: order?.preQualificationFreeInstallmentCount ?? 0
      })
    } else {
      setData(initData)
      setSelectedPayment(null)
    }
    setTheme(order?.vendorShortName)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order])

  const handleChangesSelectedPayment = useCallback((val: SelectedPaymentType) => {
    setSelectedPayment(val)
  }, [])

  return (
    <OrderContext.Provider
      value={{
        order,
        setOrder,
        contextData: data,

        selectedPayment,
        handleChangesSelectedPayment,
      }}
    >
      {children}
    </OrderContext.Provider>
  )
}
